import { render, staticRenderFns } from "./teamSharePrizes.vue?vue&type=template&id=33225d52&scoped=true"
import script from "./teamSharePrizes.vue?vue&type=script&lang=js"
export * from "./teamSharePrizes.vue?vue&type=script&lang=js"
import style0 from "./teamSharePrizes.vue?vue&type=style&index=0&id=33225d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33225d52",
  null
  
)

export default component.exports